import React from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { PATHS } from 'constants';
import { Col, Row } from 'react-bootstrap';
import LeftNav from 'components/default/LeftNav';
import UsageDashboard from './UsageDashboard';
import Movies from './Movies';
import TVShows from './TVShows';
import TVEpisodes from './TVEpisodes';
import LiveTV from './LiveTV';
import AudioAlbums from './AudioAlbums';
import AudioTracks from './AudioTracks';
import Games from './Games';
import MovingMap from './MovingMap';
import KidsGUI from './KidsGUI';
import AdVideos from './AdVideos';
import StaticAds from './StaticAds';

import styles from './styles.module.css';

const Usage = () => {
  const params = useParams();
  const navigate = useNavigate();

  const NavMap = {
    Overview: [
      {
        display: 'Dashboard',
        id: 'dashboard',
      },
    ],
    Entertainment: [
      {
        display: 'Movies',
        id: 'movies',
      },
      {
        display: 'TV shows',
        id: 'tvShows',
      },
      {
        display: 'TV episodes',
        id: 'tvEpisodes',
      },
      {
        display: 'Live TV',
        id: 'liveTv',
      },
      {
        display: 'Audio albums',
        id: 'audioAlbums',
      },
      {
        display: 'Audio tracks',
        id: 'audioTracks',
      },
    ],
    Applications: [
      {
        display: 'Games',
        id: 'games',
      },
      {
        display: 'Moving map',
        id: 'movingMap',
      },
      {
        display: 'Kids GUI',
        id: 'kidsGui',
      },
    ],
    Ads: [
      {
        display: 'Ad videos',
        id: 'adVideos',
      },
      {
        display: 'Static ads',
        id: 'staticAds',
      },
    ],
  };

  const activeMenuItem = params && params.page ? params.page : 'dashboard';

  const renderMenuItem = () => {
    switch (activeMenuItem) {
      case 'movies':
        return <Movies />;
      case 'tvShows':
        return <TVShows />;
      case 'tvEpisodes':
        return <TVEpisodes />;
      case 'liveTv':
        return <LiveTV />;
      case 'audioAlbums':
        return <AudioAlbums />;
      case 'audioTracks':
        return <AudioTracks />;
      case 'games':
        return <Games />;
      case 'movingMap':
        return <MovingMap />;
      case 'kidsGui':
        return <KidsGUI />;
      case 'adVideos':
        return <AdVideos />;
      case 'staticAds':
        return <StaticAds />;
      case 'dashboard':
      default:
        return <UsageDashboard />;
    }
  };

  return (
    <Row className={styles.root} data-cy-id="Usage" noGutters>
      <Col md="auto" className={styles.leftPanel}>
        <LeftNav
          activeMenuItem={activeMenuItem}
          changeActiveMenu={(id) => {
            navigate(`${PATHS.usage}/${id}`);
          }}
          navMap={NavMap}
          primaryHeader="Usage"
          testIdPrefix="Usage"
        />
      </Col>
      <Col className={styles.container}>{renderMenuItem()}</Col>
    </Row>
  );
};

const state = () => {
  return {};
};

const actions = {};

export default connect(state, actions)(Usage);
